import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import { useOrgStore } from '@/stores/org-store';
import { agentConversationsQueryPrefix } from '@/hooks/queries/agents/use-agent-conversations';
import { deleteAgentConversation } from '@/services/agents/config';

export const useDeleteAgentConversation = (agentId: string | undefined) => {
  const queryClient = useQueryClient();
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useMutation<void, Error, string>({
    mutationFn: (conversationId) =>
      deleteAgentConversation(orgId!, agentId!, conversationId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: agentConversationsQueryPrefix(orgId, agentId),
      });
    },
    onError: (error, conversationId) => {
      Sentry.captureException(error, {
        extra: {
          context: 'delete-agent-conversation',
          orgId,
          agentId,
          conversationId,
        },
      });
    },
  });
};
